import { MagicLinkForm } from "./LoginPage";

/*
 * Trial and price facts quoted on this page. Keep them in step with the code that enforces them:
 * TRIAL_DAYS in packages/billing/src/jobs.ts (14; 90 for FormOne webhook workspaces), TRIAL_LIMITS in
 * packages/core/src/entitlements.ts (2,000 vendors, 3 users) and the billing.plan seed in
 * packages/db/migrations (Starter PKR 1,999 a month for 250 vendors).
 */
const TRIAL_DAYS = 14;
const TRIAL_VENDORS = "2,000";
const TRIAL_USERS = 3;
const STARTER = { price: "PKR 1,999", vendors: 250 };

/**
 * Sign-up is the same magic link as sign-in: the first verified sign-in of a new address creates the
 * workspace on the standard trial (apps/api auth.verify). One field; nothing else is asked up front.
 */
export function SignupPage() {
  return (
    <div className="auth">
      <div>
        <h1>Start with your work email.</h1>
        <p className="lede">
          We send a sign-in link. Then you upload your list. The first check arrives within 24 hours. Nothing
          else to fill in; no card.
        </p>
      </div>

      <MagicLinkForm
        next="/vendors"
        submitLabel="Send link"
        after={
          <p className="fine">
            CheckOne reports FBR's published status and keeps a dated record. It is not tax advice.
          </p>
        }
      />

      <ol className="steps-3" aria-label="What happens next">
        <li>
          <span className="n" aria-hidden="true">
            1
          </span>
          <span>Open the link. Your workspace is ready.</span>
        </li>
        <li>
          <span className="n" aria-hidden="true">
            2
          </span>
          <span>Drop your vendor list. We suggest the columns; you confirm.</span>
        </li>
        <li>
          <span className="n" aria-hidden="true">
            3
          </span>
          <span>Add a WhatsApp number when you want the Monday message there too.</span>
        </li>
      </ol>

      <p className="fine">
        {TRIAL_DAYS} days free, for up to {TRIAL_VENDORS} vendors and {TRIAL_USERS} users. After that, Starter
        is {STARTER.price} a month for {STARTER.vendors} vendors, if you choose to continue. Incorporated
        through FormOne? Use the email you gave FormOne: your workspace is already set up, with three months
        free.
      </p>
    </div>
  );
}
